export default {
  date: {
    y: "years",
    m: "months",
    d: "days",
  },

  time: {
    h: "hours",
    min: "minutes",
    s: "second",
    ago: "ago",
    present: "present",
    justNow: "just now",
  },

  // no data
  noData: "No data",
  noDataFound: "No data",
  checkAgain: "Please check again or contact the administrator",

  //not specified
  notSpecified: "Not Specified",

  //check document
  checkDocs: {
    code_0: "Digital signatures and XML are not trusted.",
    code_1: "Digital signatures are reliable, but XML is not.",
    code_2: "Digital signatures and XML are reliable.",
  },

  people: "",
  times: "",

  dialogConfirm: {
    unsavedDataTitle: "You have unsaved changes",
    leavePageMessage: "Do you want to leave this page?",
    confirmDeleteMessage: "Are you sure you want to delete this data?",
    confirmSaveMessage: "Are you sure you want to save this data?",
    success: "Success",
    saveSuccess: "Data has been saved successfully",

    error: "Something went wrong",
    saveFailed: "Unable to save data",

    invalidFormMessage: "Please check that the information entered is correct",

    leavePage: "Leave this page",
    cancelEditMessage: "Do you want to cancel this edit?",
  },

  dialogEditStatus: {
    recruitmentAnnouncementTitle: "Job Announcement",
    reopenRecruitmentMessage: "Do you want to reopen recruitment for this position?",
    editRecruitmentDateMessage: "If you want to change the recruitment date",
    manageJobMessage: "You can manage it in each job's management section",
    closeRecruitmentTitle: "Close Recruitment",
    closeRecruitmentMessage: "Do you want to close this recruitment?",
  },

  statusButton: {
    open: "Open",
    openRecruitment: "Open Recruitment",
    close: "Close",
    cancel: "Cancel",
    confirm: "Confirm",
    save: "Save",
    saveData: "Save Data",
    ok: "OK",
  },

  home: {
    select: "Select the company you want to access",
    placeholder: "Search company",
    nodata: "No company data found for your search",
  }
};
